import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { HomeFilled } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'



export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const handleClick = () => {
    window.location.href = '/home'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cursor-pointer",
    onClick: handleClick
  }, [
    _createVNode(_unref(ElIcon), { size: "20" }, {
      default: _withCtx(() => [
        _createVNode(_unref(HomeFilled))
      ]),
      _: 1
    })
  ]))
}
}

})